import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';
export function ContactFormSection() {
  const form = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.current) return;
    setStatus('submitting');
    // NOTA: Asegúrate de instalar emailjs: npm install @emailjs/browser
    // Reemplaza 'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', y 'YOUR_PUBLIC_KEY' con los de Doctor Ecommerce
    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_PUBLIC_KEY').then(() => {
      setStatus('success');
      form.current?.reset();
    }).catch(error => {
      console.error('EmailJS Error:', error);
      setStatus('error');
    });
  };
  return <section id="contact-form" className="py-24 px-4 sm:px-6 lg:px-8 bg-carbon-light border-t border-carbon-lighter scroll-mt-10" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-4">
            Aplica para el <span className="text-gold" data-id="element-5">Sistema A.C.E.™</span>
          </h2>
          <p className="text-gray-400" data-id="element-6">
            Completa este formulario para analizar tu negocio antes de nuestra
            llamada. Esto nos permite darte una estrategia exacta para tu
            mercado.
          </p>
        </div>

        <div className="bg-carbon border border-carbon-lighter rounded-xl p-6 md:p-10 shadow-2xl" data-id="element-7">
          {status === 'success' ? <div className="text-center py-12" data-id="element-8">
              <CheckCircle2 className="w-16 h-16 text-emerald mx-auto mb-6" data-id="element-9" />
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-10">
                ¡Solicitud Recibida!
              </h3>
              <p className="text-gray-400 mb-8" data-id="element-11">
                Hemos recibido tu información. Si aún no has agendado tu cita en
                el calendario, hazlo ahora mismo.
              </p>
              <a href="https://calendar.app.google/gDsqAVqmwUYmaZHe9" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-carbon font-bold text-lg bg-gold hover:bg-gold-light transition-all rounded-sm" data-id="element-12">
                AGENDAR MI CITA AHORA
              </a>
            </div> : <form ref={form} onSubmit={sendEmail} className="space-y-6" data-id="element-13">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-14">
                {/* Nombre */}
                <div className="space-y-2" data-id="element-15">
                  <label htmlFor="user_name" className="block text-sm font-medium text-gray-300" data-id="element-16">
                    Nombre Completo *
                  </label>
                  <input type="text" name="user_name" id="user_name" required className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Ej. Juan Pérez" data-id="element-17" />
                </div>

                {/* Email */}
                <div className="space-y-2" data-id="element-18">
                  <label htmlFor="user_email" className="block text-sm font-medium text-gray-300" data-id="element-19">
                    Correo Electrónico *
                  </label>
                  <input type="email" name="user_email" id="user_email" required className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="tu@email.com" data-id="element-20" />
                </div>

                {/* Teléfono */}
                <div className="space-y-2" data-id="element-21">
                  <label htmlFor="user_phone" className="block text-sm font-medium text-gray-300" data-id="element-22">
                    Número de Teléfono *
                  </label>
                  <input type="tel" name="user_phone" id="user_phone" required className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="+1 (555) 000-0000" data-id="element-23" />
                </div>

                {/* Compañía */}
                <div className="space-y-2" data-id="element-24">
                  <label htmlFor="company_name" className="block text-sm font-medium text-gray-300" data-id="element-25">
                    Nombre de la Compañía *
                  </label>
                  <input type="text" name="company_name" id="company_name" required className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Ej. Sparkle Clean LLC" data-id="element-26" />
                </div>

                {/* Instagram */}
                <div className="space-y-2" data-id="element-27">
                  <label htmlFor="instagram" className="block text-sm font-medium text-gray-300" data-id="element-28">
                    Instagram de la Compañía
                  </label>
                  <input type="text" name="instagram" id="instagram" className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="@tu_empresa" data-id="element-29" />
                </div>

                {/* Website */}
                <div className="space-y-2" data-id="element-30">
                  <label htmlFor="website" className="block text-sm font-medium text-gray-300" data-id="element-31">
                    Sitio Web (Opcional)
                  </label>
                  <input type="url" name="website" id="website" className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="https://www.tuempresa.com" data-id="element-32" />
                </div>
              </div>

              <div className="border-t border-carbon-lighter pt-6 mt-6 space-y-6" data-id="element-33">
                <h3 className="text-lg font-semibold text-gold" data-id="element-34">
                  Sobre tu negocio
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-35">
                  {/* Clientes actuales */}
                  <div className="space-y-2" data-id="element-36">
                    <label htmlFor="current_clients" className="block text-sm font-medium text-gray-300" data-id="element-37">
                      ¿Cuántos clientes tienes por semana actualmente?
                    </label>
                    <input type="number" name="current_clients" id="current_clients" required min="0" className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Ej. 5" data-id="element-38" />
                  </div>

                  {/* Meta de clientes */}
                  <div className="space-y-2" data-id="element-39">
                    <label htmlFor="goal_clients" className="block text-sm font-medium text-gray-300" data-id="element-40">
                      ¿Cuál es tu meta de clientes nuevos por semana?
                    </label>
                    <input type="number" name="goal_clients" id="goal_clients" required min="1" className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Ej. 15" data-id="element-41" />
                  </div>
                </div>

                {/* Experiencia en Ads */}
                <div className="space-y-2" data-id="element-42">
                  <label htmlFor="ads_experience" className="block text-sm font-medium text-gray-300" data-id="element-43">
                    ¿Has hecho publicidad antes (Ads)? ¿Cuánto has gastado
                    aprox?
                  </label>
                  <textarea name="ads_experience" id="ads_experience" rows={3} required className="w-full bg-carbon-light border border-carbon-lighter rounded-md px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-none" placeholder="Ej. Sí, gasté $500 en Facebook Ads pero no conseguí buenos clientes..." data-id="element-44" />
                </div>
              </div>

              {status === 'error' && <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-md flex items-center" data-id="element-45">
                  <AlertCircle className="w-5 h-5 mr-2 shrink-0" data-id="element-46" />
                  <p className="text-sm" data-id="element-47">
                    Hubo un error al enviar el formulario. Por favor, intenta de
                    nuevo o agenda directamente en el calendario.
                  </p>
                </div>}

              <button type="submit" disabled={status === 'submitting'} className="w-full flex items-center justify-center px-8 py-4 text-carbon font-bold text-lg bg-gold hover:bg-gold-light transition-all duration-300 rounded-sm disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-48">
                {status === 'submitting' ? <>
                    <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-49" />
                    ENVIANDO SOLICITUD...
                  </> : 'ENVIAR SOLICITUD Y AGENDAR LLAMADA'}
              </button>
            </form>}
        </div>
      </div>
    </section>;
}